import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';

export interface MealCreditNameInputProps {
  name: string;
  id: string;
}

export function MealCreditNameInput({
  name,
  id,
}: MealCreditNameInputProps): JSX.Element {
  const { errors, control } = useFormContext();

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      maxLength={30}
      control={control}
      error={errors[name]}
      aria-label={name}
      inputSize="medium"
      blockWidth
      label="Meal credit name"
      placeholder="e.g. Friday lunch meal"
      rules={{
        required: 'Meal credit name is required',
        maxLength: {
          value: 30,
          message: 'Meal credit name must be 30 characters or less',
        },
      }}
    />
  );
}
